import $ from 'jquery'
import {getQS} from './utils'

var qs = getQS()
var debug = qs.debug
var showOwl = function (owl, pseudo) {
    var fadeDuration = 2000
    owl.fadeIn(fadeDuration)
    owl.find('.owl-stage-outer').fadeIn(fadeDuration)
    if (!debug) {
      // console.log('fade in start')
      // pseudo.fadeOut(fadeDuration, 'linear', () => {
      //   pseudo.remove()
        // console.log('fade in end')
      pseudo.css('z-index', 0);
      // })
    }
}
var fn = (function(){
  var vueRendered = !!$('.movie-booking-slider-helper').length
  var pseudoSlider = $('[data-pseudo-slider]');
  // console.log(pseudoSlider)
  if (pseudoSlider.length) {
    pseudoSlider.each(function () {
      var pseudo = $(this)
      var hasVue = !!(pseudo.attr('data-vue') || false)
      var forOwlSelector = pseudo.attr('data-for') || '.owl-carousel'
      // console.log(forOwlSelector)
      if (forOwlSelector) {
        var owl = $(forOwlSelector)
        var rendered = !!owl.attr('date-owl-rendered')
        // console.log(owl.length)
        // console.log({rendered})
        if (rendered) {
            $(function(){
              showOwl(owl, pseudo)
            })
        }
        else {
          owl.hide()
          if (!vueRendered && hasVue) {

            owl.attr('data-proxy', '.' + pseudo.attr('class').replace(/\s+?/g, '.'))

          } else {

            if (owl.hasClass('owl-loaded')) {
              showOwl(owl, pseudo)
            } else {
              $(function(){
                showOwl(owl, pseudo)
              })
            }
          }
        }
      }
    })
  }
}())

export default {}
